$(document).ready(function(){
    $(".contact__details_footer .contact_details_heading").click(function(e){
     e.preventDefault();
    e.stopPropagation();
    $(this).parents(".contact__details_footer").toggleClass("active");
    $(this).parents(".contact__details_footer").find(".footer-block").slideToggle();  
    $(this).parents(".contact__details_footer").nextAll(".content-toggle").removeClass("active");
    $(this).parents(".contact__details_footer").prevAll(".content-toggle").removeClass("active");
    $(this).parents(".contact__details_footer").nextAll(".content-toggle").find(".footer-block").slideUp();
    $(this).parents(".contact__details_footer").prevAll(".content-toggle").find(".footer-block").slideUp();
  });
  $(".newsletter-footer-mobile-s").addClass("active");
  $(".newsletter-footer-mobile-s").find(".footer-block").show();
  if($(".wpbingo-title h3.wpbingo-title__heading").is(":visible")){
     var element = $(".wpbingo-title h3.wpbingo-title__heading");
  var position = element.position();
  console.log(position.left)
  $(".wpbingo-product-page-slider .slick-list").css({"margin-left":position.left});
  }
 

if($(".combined_product-heading h3").is(":visible")){
  var element1 = $(".combined_product-heading h3");
  var position1 = element1.position();
  console.log(position1.left)
  $(".combined_product .slick-list").css({"margin-left":position1.left});
}
  
});
$(document).on('click','button.js-mm-nav-item.mm-nav__btn',function(){
    $("a.js-mm-nav-item-alt.mm-nav__prev-alt").addClass("active-menu-main");
  })
$(document).on('click','a.js-mm-nav-item.mm-nav__prev',function(){
    $("a.js-mm-nav-item-alt.mm-nav__prev-alt").removeClass("active-menu-main");
  })
$(window).resize(function(){
   if($(".wpbingo-title h3.wpbingo-title__heading").is(":visible")){
     var element = $(".wpbingo-title h3.wpbingo-title__heading");
  var position = element.position();
  console.log(position.left)
  $(".wpbingo-product-page-slider .slick-list").css({"margin-left":position.left});
  }
 

if($(".combined_product-heading h3").is(":visible")){
  var element1 = $(".combined_product-heading h3");
  var position1 = element1.position();
  console.log(position1.left)
  $(".combined_product .slick-list").css({"margin-left":position1.left});
}
})

// $(document).ready(checkContainerr);

// function checkContainerr() {
//   if($('div#etranslate-language-float-selector-theme2').is(':visible')){ //if the container is visible on the page
//      console.log("found translate app")
//     var translate = $( "div#etranslate-language-float-selector-theme2" ).get();
//     $( ".content-item-social ul.social-icons" ).append(translate);
//   } else {
    
//     setTimeout(checkContainerr, 50); //wait 50 ms, then try again
    
//   }


document.addEventListener('DOMContentLoaded', function () {
    // Selector del contenedor de las imágenes principales
    const mediaGroup = document.querySelector('.js-product-media-group');
    // Selector del elemento de la miniatura del packaging
    const packagingImg = document.getElementById('packaging_img');

    // Detectar el idioma de la tienda
    const currentLang = document.documentElement.lang || 'es'; // Predeterminado: español

    // Determinar la URL de la imagen según el idioma
    const packagingImageUrl = currentLang === 'en' 
        ? 'https://cdn.shopify.com/s/files/1/0770/6027/6540/files/packaging_EN.jpg?v=1737461753'
        : 'https://cdn.shopify.com/s/files/1/0770/6027/6540/files/packaging_ES.jpg?v=1737461754';

    if (mediaGroup && packagingImg) {
        // Crea el div con la imagen del packaging
        const packagingDiv = document.createElement('div');
        packagingDiv.id = 'packaging_display';
        packagingDiv.style.cssText = `
            display: none;
            width: 100%;
            text-align: center;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 10;
            opacity: 0;
            transition: opacity 0.4s ease;
        `;
        packagingDiv.innerHTML = `
            <img src="${packagingImageUrl}" 
                 alt="Packaging Image" 
                 style="max-width: 100%; height: auto;">
        `;

        // Asegúrate de que el contenedor tiene position: relative
        const parentContainer = mediaGroup.parentElement;
        parentContainer.style.position = 'relative';

        // Inserta el div después de mediaGroup
        mediaGroup.insertAdjacentElement('afterend', packagingDiv);

        // Agrega un listener para el clic en la imagen del packaging
        packagingImg.addEventListener('click', function () {
            mediaGroup.style.opacity = '0'; // Oculta visualmente el grupo de imágenes
            mediaGroup.style.pointerEvents = 'none'; // Deshabilita la interacción
            packagingDiv.style.display = 'block'; // Muestra el div
            setTimeout(() => {
                packagingDiv.style.opacity = '1'; // Efecto de transición al mostrar
            }, 10); // Pequeño retraso para activar la transición
        });

        // Listener para ocultar el packaging y restaurar las imágenes originales
        document.addEventListener('click', function (e) {
            if (e.target.id !== 'packaging_img' && e.target.parentNode !== packagingDiv) {
                packagingDiv.style.opacity = '0'; // Efecto de transición al ocultar
                setTimeout(() => {
                    packagingDiv.style.display = 'none'; // Oculta el div completamente
                    mediaGroup.style.opacity = '1'; // Restaura la visibilidad del grupo de imágenes
                    mediaGroup.style.pointerEvents = 'auto'; // Habilita la interacción
                }, 500); // Tiempo de la transición
            }
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    // Seleccionar todos los contenedores de imágenes del producto
    const productMediaWrappers = document.querySelectorAll('.product-media__wrapper.product-media__wrapper--image');


    productMediaWrappers.forEach((wrapper, index) => {

        // Selecciona el botón de zoom dentro del contenedor
        const galleryCursor = wrapper.querySelector('.gallery-cursor');

        if (galleryCursor) {

            let isCursorInside = false; // Controla si el cursor está dentro del contenedor

            // Manejar el evento `mouseenter` para mostrar el botón de zoom
            wrapper.addEventListener('mouseenter', function () {
                isCursorInside = true; // Marca que el puntero está dentro
                galleryCursor.classList.add('show');
                 wrapper.style.cursor = 'none';
            });

            // Manejar el evento `mouseleave` para ocultar el botón de zoom
            wrapper.addEventListener('mouseleave', function () {
                isCursorInside = false; // Marca que el puntero está fuera
                galleryCursor.classList.remove('show');
                wrapper.style.cursor = 'default'; // Restablece el cursor
            });

            // Verificación constante para mantener sincronizado el estado
            document.addEventListener('mousemove', function (event) {
                const rect = wrapper.getBoundingClientRect(); // Obtiene las dimensiones del contenedor
                const isInside = (
                    event.clientX >= rect.left &&
                    event.clientX <= rect.right &&
                    event.clientY >= rect.top &&
                    event.clientY <= rect.bottom
                );

                // Actualiza el estado inmediatamente si no coincide
                if (!isInside && isCursorInside) {
                    isCursorInside = false;
                    galleryCursor.classList.remove('show');
                    wrapper.style.cursor = 'default'; // Restablece el cursor
                }
            });

            // Forzar la visibilidad correcta en caso de inconsistencias
            wrapper.addEventListener('mousemove', function (event) {
                const rect = wrapper.getBoundingClientRect();
                const isInside = (
                    event.clientX >= rect.left &&
                    event.clientX <= rect.right &&
                    event.clientY >= rect.top &&
                    event.clientY <= rect.bottom
                );

                if (isInside && !isCursorInside) {
                    isCursorInside = true;
                    galleryCursor.classList.add('show');
                    wrapper.style.cursor = 'none';
                }
            });
        } else {
        }
    });
});

